module.exports = __webpack_public_path__ + "static/media/icon-whatsapp.ce0575c1.svg";